import { CoreModel, getNewErrors, InputErrorModel, UtilityMethods } from "@mindmemobile/mm-shared-global";
import { autorun } from "mobx";  
import { MerchantAccount } from "./MerchantApplicationInputModel";
import { SellerModel } from "./SellerModels";
import { CheckOutDisplayTypes } from "../enums"; 
import { IAPICheckOutDetailModel, IAPICheckOutSaveUpdateModel } from "../interfaces/IAPICheckoutModel";
 
export class CheckoutDetailPageModel extends CoreModel {
    id: string;
    name: string;
    isActive: boolean;
    isDonationOnly: boolean;
    // itemsType: string;
    showSingleItemPrice: boolean;
    isMerchantDropdownOpen: boolean;
    isSellerDropdownOpen: boolean;
    selectedMerchantAccount: MerchantAccount;
    selectedSeller: SellerModel;
    selectedDisplayType: keyof typeof CheckOutDisplayTypes;
    createdBy: string;
    createdDate: Date | null;
    errors: InputErrorModel<CheckoutDetailPageModel>[];
    constructor(data?: Partial<CheckoutDetailPageModel>) {
        super();
        this.id = data?.id || '';
        this.name = (data && data.name) || '';
        this.isActive = (data && data.isActive) || false;
        //this.itemsType = data?.itemsType || checkoutItemsType[0].key;
        this.showSingleItemPrice = data?.showSingleItemPrice === true;
        this.isMerchantDropdownOpen = data?.isMerchantDropdownOpen || false;
        this.isSellerDropdownOpen = data?.isSellerDropdownOpen || false;
        this.selectedMerchantAccount = data?.selectedMerchantAccount || new MerchantAccount();
        this.selectedSeller = data?.selectedSeller || new SellerModel();
        this.createdBy = data?.createdBy || '';
        this.createdDate = data?.createdDate || null;
        this.isDonationOnly = data?.isDonationOnly || false;

        if (!data?.selectedDisplayType) {
            this.selectedDisplayType = CheckOutDisplayTypes.SingleItem;
            this.showSingleItemPrice = true;
        } else {
            this.selectedDisplayType = data?.selectedDisplayType;
        }

        if (!data) {
            this.isActive = true;
        }
        this.errors =
            (data &&
                data.errors?.map((e) => {
                    return new InputErrorModel<CheckoutDetailPageModel>(e);
                })) ||
            [];

        autorun(() => {
            this.validate(true);
        });
    }

    hasError(field: keyof CheckoutDetailPageModel): boolean {
        return this.errors.some((e) => e.field === field);
    }

    validate(isAutoRun = false): boolean {
        const newErrors: InputErrorModel<CheckoutDetailPageModel>[] = [];
        this.validateTextField(this.name, 'name', newErrors);
        this.validateTextField(this.selectedMerchantAccount.applicationId, 'selectedMerchantAccount', newErrors);
        this.validateTextField(this.selectedDisplayType, 'selectedDisplayType', newErrors);
        this.validateTextField(this.selectedSeller.name, 'selectedSeller', newErrors);
        if (isAutoRun) {
            this.errors = getNewErrors(newErrors, this.errors);
        } else {
            this.errors = newErrors;
        }
        return this.errors.length === 0;
    }

    createAPIModel(): IAPICheckOutDetailModel {
        return {
            id: this.id,
            name: this.name,
            isActive: this.isActive,
            showSingleItemPrice: this.showSingleItemPrice,
            merchantAccount: this.selectedMerchantAccount.createAPIModel2(),
            seller: this.selectedSeller.createAPIModel(),
            displayType: this.selectedDisplayType,
            isDonationOnly: this.isDonationOnly,
        };
    }

    static deserializeAPIModel(data: IAPICheckOutSaveUpdateModel): CheckoutDetailPageModel {
        return new CheckoutDetailPageModel({
            id: data.id,
            name: data.name,
            isActive: data.isActive,
            selectedMerchantAccount: new MerchantAccount({
                applicationId: data.merchantAccount.applicationId,
                merchantAccountId: data.merchantAccount.merchantAccountId,
                name: data.merchantAccount.name,
                gateway: data.merchantAccount.gateway,
            }),
            selectedSeller: data.seller && SellerModel.deserializeAPIModel(data.seller),
            selectedDisplayType: data.displayType,
            showSingleItemPrice: data.showSingleItemPrice,
            createdBy: data.createdBy,
            createdDate: UtilityMethods.removeZFromDateString(data.createdDate || ''),
            isDonationOnly: data.isDonationOnly,
        });
    }
}
